import DOMPurify from 'dompurify'

// 富文本/文章正文安全渲染：去除 script/事件属性/javascript: 等 XSS 载荷
export function sanitizeHtml(html) {
  if (!html) return ''
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
  })
}
